import { skipToken } from '@apollo/client/react'
import { useCheckTokenForArgs } from 'src/utils/token'
import {
  ClaimShareCreditDocument,
  GetMeWithQuotaForCurrencyDocument,
  GetMyQuotaDocument,
  GetMyShareCreditInfoDocument,
  GetUserQuotaDocument,
  ListMyQuotaLogsDocument,
  ListUserQuotaLogsDocument,
} from './generated/graphql'
import {
  createMutationHelper,
  createQueryHook,
  createRefetchQueryHelper,
  modifyQueryHook,
} from './utils'

const useGetMyQuota = modifyQueryHook(createQueryHook(GetMyQuotaDocument), {
  reduce: r => r?.me?.quotaAmount ?? 0,
})
export const useMyQuota = (options?: Parameters<typeof useGetMyQuota>[1]) => {
  const input = useCheckTokenForArgs({})
  const res = useGetMyQuota(input ?? skipToken, options)
  return res
}
export const refetchGetMyQuota = createRefetchQueryHelper(GetMyQuotaDocument)

export const useGetMeWithQuotaForCurrency = modifyQueryHook(
  createQueryHook(GetMeWithQuotaForCurrencyDocument),
  {
    reduce: r => r?.me,
  },
)

export const useGetMyShareCreditInfo = modifyQueryHook(
  createQueryHook(GetMyShareCreditInfoDocument),
  {
    reduce: r => r?.me?.shareCreditInfo,
  },
)

export const [useClaimShareCredit, executeClaimShareCredit] =
  createMutationHelper(ClaimShareCreditDocument)

export const useListUserQuotaLogs = modifyQueryHook(
  createQueryHook(ListUserQuotaLogsDocument),
  {
    reduce: r => r?.user?.quotaLogs,
  },
)

export const useGetUserQuota = modifyQueryHook(
  createQueryHook(GetUserQuotaDocument),
  {
    transform: (userId: string) => ({ userId }),
    reduce: r => r?.user,
  },
)

export const useListMyQuotaLogs = modifyQueryHook(
  createQueryHook(ListMyQuotaLogsDocument),
  {
    reduce: r => r?.me?.quotaLogs,
  },
)
